import React from 'react';

const COMPANY = 'Velopulse';
const DOMAIN = 'velopulse.io';
const EMAIL = 'privacy@velopulse.io';
const UPDATED = '2026-03-10';

export default function PrivacyPolicyPage() {
  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#fff', letterSpacing: 1 }}>
            {COMPANY}
          </div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>
            隱私權政策 Privacy Policy
          </div>
        </div>

        <div style={bodyStyle}>
          <p style={metaStyle}>最後更新日期：{UPDATED}</p>

          <Section title="一、前言">
            <p>
              歡迎使用 {COMPANY} 智慧表單 CRM 平台（以下簡稱「本平台」）及其相關服務，
              包含 {COMPANY} CRM Sync Bridge Chrome 擴充功能（以下簡稱「擴充功能」）。
              我們非常重視您的隱私權，本政策說明我們如何收集、使用、儲存及保護您的個人資料。
            </p>
          </Section>

          <Section title="二、資料收集範圍">
            <SubSection title="2.1 平台服務">
              <ul style={ulStyle}>
                <li>帳號註冊資訊：姓名、電子郵件、密碼（加密儲存）</li>
                <li>表單提交資料：使用者透過表單填寫的客戶資訊（姓名、電話、電子郵件、公司名稱等）</li>
                <li>操作記錄：登入時間、表單建立與提交記錄</li>
              </ul>
            </SubSection>
            <SubSection title="2.2 Chrome 擴充功能">
              <ul style={ulStyle}>
                <li>連線設定：平台伺服器網址與 Extension Token（僅儲存於使用者本機）</li>
                <li>CRM 頁面互動：擴充功能會讀取當前 CRM 頁面的表單欄位結構，以便自動填入資料</li>
                <li>螢幕截圖：填寫 CRM 表單後擷取截圖，供使用者確認資料正確性</li>
              </ul>
              <p style={{ marginTop: 8, color: '#64748b', fontSize: 13 }}>
                擴充功能<strong>不會</strong>收集瀏覽記錄、搜尋記錄、鍵盤輸入或任何與 CRM 同步無關的個人資料。
              </p>
            </SubSection>
          </Section>

          <Section title="三、資料使用目的">
            <ul style={ulStyle}>
              <li>提供及維護本平台的表單管理、CRM 同步等核心服務</li>
              <li>透過擴充功能將表單資料自動填入 CRM 系統（如 Salesforce、HubSpot、Zoho）</li>
              <li>產生同步記錄與截圖，供使用者追蹤及確認同步狀態</li>
              <li>改善服務品質與使用者體驗</li>
              <li>發送系統通知（如同步結果通知）</li>
            </ul>
          </Section>

          <Section title="四、資料儲存與安全">
            <ul style={ulStyle}>
              <li>所有密碼皆以 bcrypt 加密儲存，不以明文保存</li>
              <li>API 通訊使用 HTTPS 加密傳輸</li>
              <li>Extension Token 使用 JWT 簽名，有效期 30 天</li>
              <li>擴充功能的連線設定僅儲存於使用者本機的 chrome.storage.local</li>
              <li>伺服器端資料儲存於受保護的雲端資料庫，具有存取控制及備份機制</li>
            </ul>
          </Section>

          <Section title="五、資料分享與第三方">
            <p>我們<strong>不會</strong>將您的個人資料販售或轉移給第三方，除非：</p>
            <ul style={ulStyle}>
              <li>經您明確同意</li>
              <li>為遵守法律義務或回應合法的法律程序</li>
              <li>為保護 {COMPANY} 或其使用者的權利與安全</li>
            </ul>
            <p style={{ marginTop: 8 }}>
              當您使用擴充功能將資料填入第三方 CRM 系統時，該資料將受該 CRM 系統之隱私權政策規範。
            </p>
          </Section>

          <Section title="六、Cookie 與追蹤技術">
            <p>
              本平台使用必要的 Cookie 維持登入狀態。我們不使用第三方追蹤 Cookie 或廣告追蹤技術。
            </p>
          </Section>

          <Section title="七、您的權利">
            <p>根據適用的資料保護法規，您享有以下權利：</p>
            <ul style={ulStyle}>
              <li><strong>查閱權</strong>：查看我們所持有的您的個人資料</li>
              <li><strong>更正權</strong>：更正不正確或不完整的個人資料</li>
              <li><strong>刪除權</strong>：要求刪除您的個人資料</li>
              <li><strong>可攜權</strong>：以結構化格式匯出您的資料</li>
              <li><strong>撤回同意權</strong>：隨時撤回對資料處理的同意</li>
            </ul>
            <p style={{ marginTop: 8 }}>
              如需行使上述權利，請透過下方聯絡方式與我們聯繫。
            </p>
          </Section>

          <Section title="八、資料保留期限">
            <p>
              我們僅在提供服務所需的期間內保留您的個人資料。當您刪除帳號後，
              我們將在合理期間內刪除或匿名化您的個人資料，除非法律要求我們保留更長時間。
            </p>
          </Section>

          <Section title="九、兒童隱私">
            <p>
              本平台及擴充功能為企業工具，不針對 16 歲以下的兒童。
              我們不會故意收集兒童的個人資料。
            </p>
          </Section>

          <Section title="十、政策變更">
            <p>
              我們可能會不時更新本隱私權政策。變更後的政策將公布於本頁面，
              並更新「最後更新日期」。重大變更時，我們將透過平台通知或電子郵件告知您。
            </p>
          </Section>

          <Section title="十一、聯絡我們" last>
            <p>如對本隱私權政策有任何疑問，請透過以下方式與我們聯繫：</p>
            <div style={contactBoxStyle}>
              <div><strong>{COMPANY}</strong></div>
              <div style={{ marginTop: 4 }}>
                電子郵件：<a href={`mailto:${EMAIL}`} style={linkStyle}>{EMAIL}</a>
              </div>
              <div style={{ marginTop: 4 }}>
                網站：<a href={`https://${DOMAIN}`} style={linkStyle}>{DOMAIN}</a>
              </div>
            </div>
          </Section>
        </div>

        {/* Footer */}
        <div style={footerStyle}>
          &copy; {new Date().getFullYear()} {COMPANY}. All rights reserved.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children, last }) {
  return (
    <div style={{ marginBottom: last ? 0 : 28 }}>
      <h2 style={sectionTitleStyle}>{title}</h2>
      <div style={sectionBodyStyle}>{children}</div>
    </div>
  );
}

function SubSection({ title, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <h3 style={subSectionTitleStyle}>{title}</h3>
      {children}
    </div>
  );
}

/* ── Styles ─────────────────────────────────────────── */

const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #0c4a3e 0%, #134e4a 40%, #f0fdf4 100%)',
  padding: '32px 16px',
  fontFamily: "'Noto Sans TC', -apple-system, BlinkMacSystemFont, sans-serif",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
};

const cardStyle = {
  width: '100%',
  maxWidth: 720,
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  overflow: 'hidden',
};

const headerStyle = {
  background: 'linear-gradient(135deg, #0c4a3e, #134e4a)',
  padding: '28px 32px',
};

const bodyStyle = {
  padding: '28px 32px',
  fontSize: 14,
  lineHeight: 1.8,
  color: '#334155',
};

const metaStyle = {
  fontSize: 13,
  color: '#94a3b8',
  marginBottom: 24,
  paddingBottom: 16,
  borderBottom: '1px solid #e2e8f0',
};

const sectionTitleStyle = {
  fontSize: 17,
  fontWeight: 700,
  color: '#0f172a',
  marginBottom: 10,
};

const sectionBodyStyle = {
  paddingLeft: 4,
};

const subSectionTitleStyle = {
  fontSize: 15,
  fontWeight: 600,
  color: '#334155',
  marginBottom: 6,
};

const ulStyle = {
  margin: '6px 0',
  paddingLeft: 20,
  listStyleType: 'disc',
};

const contactBoxStyle = {
  marginTop: 12,
  padding: '14px 18px',
  background: '#f8fafc',
  borderRadius: 10,
  border: '1px solid #e2e8f0',
  fontSize: 14,
};

const linkStyle = {
  color: '#0d9488',
  textDecoration: 'none',
};

const footerStyle = {
  textAlign: 'center',
  padding: '16px 32px',
  fontSize: 12,
  color: '#94a3b8',
  borderTop: '1px solid #f1f5f9',
};
